import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6b01,
  properties: ["read", "write", "notify"],
};

export function generateMockDURNofifyData(): DomianControl.ICCNotifyData {
  const data = getMockDataByKeys(
    [
      "UIRx_DUFlg_FL",
      "UIRx_DUFlg_FR",
      "UIRx_DUFlg_RL",
      "UIRx_DUFlg_RR",
      "UIRx_DUIdx_FL",
      "UIRx_DUIdx_FR",
      "UIRx_DUIdx_RL",
      "UIRx_DUIdx_RR",
      "UIRx_SuspHgtAmp_FL",
      "UIRx_SuspHgtAmp_FR",
      "UIRx_SuspHgtAmp_RL",
      "UIRx_SuspHgtAmp_RR",
    ]
    // {
    //   UIRx_ACULatAcc:[-1, 1],
    //   UIRx_ACULongdAcc:[-1, 1],
    //   UIRx_ACUYawRate:[-75, 75],
    //   UIRx_DeltaOff_FA:[-5, 5],
    //   UIRx_SBW_HWAAng:[-500, 500],
    //   UIRx_DeltaOff_RA:[-5, 5],
    //   UIRx_alphaRA:[-5, 5],
    //   UIRx_WhlBrkTqAct_FL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_FR_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RR_BCh1:[0, 2000],
    // }
  );
  return data;
}
